import { Outlet } from "react-router-dom";
import { AuthShell } from "@void-orbit/ui";

export const AuthLayout = () => {
  return (
    <AuthShell
      product="chat"
      productName="Void Chat"
      brandEyebrow="Atendimento em orbita"
      brandDescription="Conecte conversas. Organize atendimento."
      eyebrow="Workspace seguro"
      title="Acesse sua conta"
      description="Entre para continuar suas conversas e operações."
    >
      <Outlet />
    </AuthShell>
  );
};
